import React, { FunctionComponent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { globalTheme } from '../../../../../shared/theme/theme';
import useChangePrompt from '../../../hooks/use-change-prompt/use-change-prompt.hook';
import ListItemIcon from '../ListItemIcon/ListItemIcon';
import MenuItem from '../MenuItem/MenuItem';
import Paper from '../Paper/Paper';
import Typography from '../Typography/Typography';
import { SidebarMenuPropsModel } from './models/sidebar-menu-props.model';

const SidebarMenuItem: FunctionComponent<SidebarMenuPropsModel> = ({
  menuItem,
  isMenuOpen,
}: SidebarMenuPropsModel) => {
  const location = useLocation();

  const isItemSelected = location.pathname.includes(menuItem.path ?? '');
  const navigate = useNavigate();

  const childMenuItemPath = `/${menuItem.path}`;
  const tabNavigate = useChangePrompt(
    true,
    () => {
      navigate(childMenuItemPath);
    },
    <span>Warning</span>,
    <span>Filled information will be lost. Leave anyway?</span>
  );
  const handleClick = () => {
    tabNavigate();
  };

  return (
    <>
      <MenuItem
        disableRipple={true}
        onClick={handleClick}
        sx={{
          padding: '0',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Paper
          component={'div'}
          sx={{
            padding: '20px',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: 'none',
            borderRadius: '0',
            backgroundColor: theme =>
              isItemSelected
                ? theme.palette.appWhite.sideBarMenuItemActive
                : theme.palette.appWhite.sideBarMenuContainerBgColor,
          }}
        >
          <Paper
            component={'div'}
            sx={{
              display: 'flex',
              alignItems: 'center',
              boxShadow: 'none',
              backgroundColor: 'transparent',
            }}
          >
            {menuItem.menuIcon && (
              <ListItemIcon>{menuItem.menuIcon}</ListItemIcon>
            )}
            <Typography
              variant="inherit"
              noWrap
              sx={{
                visibility: isMenuOpen ? 'visible' : 'hidden',
                color: isItemSelected
                  ? globalTheme.palette.primary.main
                  : 'inherit',
                '&:hover': {
                  color: globalTheme.palette.primary.main,
                },
              }}
            >
              {menuItem.title}
            </Typography>
          </Paper>
        </Paper>
      </MenuItem>
    </>
  );
};

export default SidebarMenuItem;
